import useProjectWithoutCalulationQuery from "@/api/query/useProjectWithoutCalulationQuery";
import { PlanType, planTypeAllow } from "@/helperFuntions/planTypeAllow";
import {
  PlanTypeEnumSchema,
  UserRoleEnumValue,
} from "@backend/src/schemas/enums";
import { useState, useEffect } from "react";
import { useUser } from "./useUser";
import { toast } from "react-toastify";
import { errorConfig } from "@/lib/toastError";
// import { usePlanValidationContext } from "@/context/paymentContext";
import useOrganisationDetailsQuery from "@/api/query/useOrganisationDetailsQuery";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { useNavigate } from "react-router-dom";
import { getCurrentUserOrganisation } from "@/utils/roleUtils";

export const usePlanValidation = () => {
  // const { openDialog } = usePlanValidationContext();
  const navigate = useNavigate();
  const [currentUsage, setCurrentUsage] = useState({
    projects: 0,
    managers: 0,
    members: 0,
  });
  const [plan, setPlan] = useState<keyof typeof PlanTypeEnumSchema | null>(
    null
  );
  const [validationMessage, setValidationMessage] = useState<string | null>(
    null
  );

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { user } = useUser();
  const projectQuery = useProjectWithoutCalulationQuery(false);
   useEffect(() => {
     if (!projectQuery.isFetched && user?.userOrganisation[0]?.organisationId) {
       projectQuery.refetch();
     }
   }, [projectQuery.isFetched,user]);
  const plans = {
    [PlanTypeEnumSchema.BUSINESS]: {
      name: PlanTypeEnumSchema.BUSINESS,
      price: 39,
      maxProjects: 5,
      maxProjectManagers: 1,
      maxProjectMembers: 6,
      features: [
        "riskManagement",
        "projectDashboard",
        "portfolioDashboard",
        "projectBudget",
      ],
    },
    [PlanTypeEnumSchema.ENTERPRISE]: {
      name: PlanTypeEnumSchema.ENTERPRISE,
      price: 69,
      maxProjects: Infinity,
      maxProjectManagers: Infinity,
      maxProjectMembers: Infinity,
      features: [
        "portfolioDashboard",
        "projectDashboard",
        "riskManagement",
        "projectBudget",
        "onboardingAndTraining",
      ],
    },
    FREE: {
      name: "FREE",
      price: 0,
      maxProjects: 2,
      maxProjectManagers: 1,
      maxProjectMembers: 3,
      features: ["na"],
    },
  };
  const organisationId = getCurrentUserOrganisation(user)?.organisationId ?? "";
  const { data ,refetch,isFetched } = useOrganisationDetailsQuery(organisationId,false);
  useEffect(() => {
    if (!isFetched && organisationId) {
      refetch()
    }
  }, [isFetched,user])
  
  const [pm, setpm] = useState<string[]>([]);
  const selectedPlan = plans[(plan as keyof typeof plans) ?? "FREE"];
  useEffect(() => {
    const fetchUserData = () => {
      if (!user) return;
      setPlan(user?.subscription?.planType ?? "FREE");

      try {
        const uniqueProjectManager = new Set<string>();
        const projectRes = projectQuery.data?.data.data?.length ?? 0;
        projectQuery.data?.data.data.forEach((project) => {
          project.assignedUsers.forEach((user) => {
            if (user.projectRole === UserRoleEnumValue.ADMINISTRATOR) {
              uniqueProjectManager.add(user.user.userId);
            }
            if (user.projectRole === UserRoleEnumValue.PROJECT_MANAGER) {
              uniqueProjectManager.add(user.user.userId);
            }
          });
        });

        // Also include organisation administrators
        data?.data.data.userOrganisation.forEach((orgMember) => {
          if (orgMember.role === UserRoleEnumValue.ADMINISTRATOR) {
            uniqueProjectManager.add(orgMember.user.userId);
          }
        });

        setpm(Array.from(uniqueProjectManager) as string[]);
        const managerRes = uniqueProjectManager.size;
        const uniqueTeamMembers = new Set<string>();

        projectQuery.data?.data.data.forEach((project) => {
          project.assignedUsers.forEach((user) => {
            if (user.projectRole === UserRoleEnumValue.TEAM_MEMBER) {
              uniqueTeamMembers.add(user.user.userId);
            }
          });
        });

        const memberRes =  data?.data.data.userOrganisation.length;
        const projects = projectRes;
        const managers = managerRes;
        const members = memberRes;

        // Update current usage with fetched data
        setCurrentUsage({
          projects: projects,
          managers: managers,
          members: members ?? 0,
        });
      } catch (error) {
        console.error("Error fetching usage data:", error);
        setValidationMessage("Failed to fetch usage data");
        setIsDialogOpen(true);
      }
    };

    fetchUserData();
  }, [user, projectQuery.data, data]);

  const validatePlan = (
    validate: "project" | "manager" | "member" | "canCreate"|"admin",
    userId?: string
  ) => {
    // Enterprise plan has seat-based charging for project managers and unlimited allocations
    if (validate === "manager" && plan === PlanTypeEnumSchema.ENTERPRISE) {
      return { valid: true };
    }

    if (userId && pm.includes(userId)) {
      return { valid: true };
    } else {
      try {
        const validation = planTypeAllow(
          plan ?? "FREE",
          currentUsage,
          validate,
          selectedPlan as PlanType
        );
        if (!validation.valid) {
          setValidationMessage(errorKeyFormate(validation.message??"") || "Invalid plan type");
          navigate("/plans");
          // openDialog();
          toast.error(errorKeyFormate(validation.message??"") || "Invalid plan type", {
            ...errorConfig,
          });
          return { valid: false, message: errorKeyFormate(validation.message??"") };
        }
        setValidationMessage(null);
        return { valid: true };
      } catch (error) {
        setValidationMessage("Error validating plan");
        return { valid: false, message: "Error validating plan" };
      }
    }
  };

  return {
    currentUsage,
    plan,
    setPlan,
    validatePlan,
    validationMessage,
    isDialogOpen,
    setIsDialogOpen,
    selectedPlan,
  };
};
